(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-instructions-instruction"] && !window.DesignMode) return;
  try {
    
// This JavaScript will only be included once, regardless of how many instances of this section exist on the page
if (!window.sectionInstructionsInitialized) {
  window.sectionInstructionsInitialized = true;
  
  $(document).ready(function() {
    // Hide all instruction containers initially
    $('.instruction-container').hide();
    
    // Use jQuery click handler with delegation
    $(document).on('click', '.accordion-header', function() {
      const clickedHeader = $(this);
      const contentContainer = clickedHeader.next('.instruction-container');
      const wasActive = clickedHeader.hasClass('active');
      
      // Close all accordions first
      $('.accordion-header.active').not(clickedHeader).each(function() {
        $(this).removeClass('active');
        $(this).find('.accordion-icon').css('transform', 'rotate(0deg)');
        $(this).next('.instruction-container').slideUp(300);
      });
      
      // Toggle the clicked accordion
      if (wasActive) {
        // If it was already active, close it
        clickedHeader.removeClass('active');
        clickedHeader.find('.accordion-icon').css('transform', 'rotate(0deg)');
        contentContainer.slideUp(300);
      } else {
        // If it was closed, open it
        clickedHeader.addClass('active');
        clickedHeader.find('.accordion-icon').css('transform', 'rotate(90deg)');
        contentContainer.slideDown(300);
      }
    });

    // Close all accordions when switching between instruction types
    $(document).on('click', '#hardware-instructions-select, #electrical-instructions-select, #lighting-instructions-select', function() {
      // Close all accordions
      $('.accordion-header.active').each(function() {
        $(this).removeClass('active');
        $(this).find('.accordion-icon').css('transform', 'rotate(0deg)');
        $(this).next('.instruction-container').slideUp(300);
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-trade-tabs"]) return;
  try {
    
  $(document).ready(function () {
    $('.trade-carousel').hide().first().show().addClass('active');
    $('.switches-sockets-landing-link').click(function () {
      var $this = $(this);
      var $siblings = $this.parent().children();
      var position = $siblings.index($this);
      $('.trade-carousel').removeClass('active').hide().eq(position).fadeIn().addClass('active');
      $siblings.removeClass('active');
      $this.addClass('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rich-media"]) return;
  try {
    
$(document).ready(function() {
  // 3-image popout video functionality
  $('.in-box-3-popout-video > .box-container').on("click", function(event) {
    $('#rich-media-popup').show();
    let container = event.target.closest(".box-container");
    
    if (screen.width < 768) {
      $('#rich-media-popup .video-section').html(
        '<iframe src="' + container.dataset.videomobile + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe>' +
        '<div class="video-section-popup"><span>' + window.theme.strings.close + ' X</span></div>'
      );
    } else {
      $('#rich-media-popup .video-section').html(
        '<iframe src="' + container.dataset.video + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe>' +
        '<div class="video-section-popup"><span>' + window.theme.strings.close + ' X</span></div>'
      );
    }

    $('.video-section-popup').on("click", function(event) {
      $('#rich-media-popup').hide();
    });
  });

  // Video popup backdrop click
  $('.video-section-backdrop').on("click", function(event) {
    $('#rich-media-popup').hide();
  });

  // Video popup close button click
  $('.video-section-popup').on("click", function(event) {
    $('#rich-media-popup').hide();
  });

  // Before/after slider functionality
  $("input.slider").on("input change", function(event) {
    var element = $(this).parents("div.before-after-container");
    var pos = event.target.value;

    if ((window.innerWidth > 767) && (pos > 60)) {
      event.target.value = pos = 60;
    }

    element.find("div.before").css({width: pos + "%"});
    element.find("div.slider-button").css({left: "calc(" + pos + "% - 18px)"});
  });

  // Scroll-based slider animation
  $(window).on("scroll", function() {
    var slider = $("input.slider");
    if (slider.length) {
      var sliderPosition = slider.offset().top;
      var sliderHeight = slider.outerHeight();
      var viewportHeight = $(window).height();
      var scrollTop = $(this).scrollTop();

      var scrollThreshold = 0;
      var sliderOffset = /Mobi|Android/i.test(navigator.userAgent) ? 400 : 50;

      if (sliderPosition >= scrollTop - scrollThreshold - sliderOffset && 
          sliderPosition <= scrollTop + viewportHeight - sliderHeight + scrollThreshold + sliderOffset) {
        var sliderValue = Math.round((sliderPosition - scrollTop + scrollThreshold + sliderOffset) * 160 / 
                                   (viewportHeight - sliderHeight + (scrollThreshold + sliderOffset) * 2));
        slider.val(160 - sliderValue).trigger("input");
        slider.parents("div.before-after-container").find("div.slider-button").css({left: "calc(" + (100 - sliderValue) + "% - 18px)"});
      } else {
        if (scrollTop < sliderPosition - scrollThreshold - sliderOffset) {
          slider.val(0).trigger("input");
          slider.parents("div.before-after-container").find("div.slider-button").css({left: "0"});
        } else {
          slider.val(160).trigger("input");
          slider.parents("div.before-after-container").find("div.slider-button").css({left: "calc(100% - 18px)"});
        }
      }
    }
  });

  // Video carousel initialization
  $('.carousel-container').slick({
    centerPadding: '60px',
    slidesToShow: 3.5,
    initialSlide: 0,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          centerPadding: '40px',
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerPadding: '40px',
          slidesToShow: 1.5
        }
      }
    ]
  });

  // Carousel item click functionality
  $('.carousel-item.slick-slide').on("click", function(event) {
    let targetSlide = $(this).data("slick-index");
    $('.carousel-container').slick('slickGoTo', targetSlide);
  });

  // 2-video-image-left functionality
  $('.box-2-video-image-left').on("click", function(event) {
    $('#rich-media-popup').show();
    let container = event.target.closest(".box-2-video-image-left");
    
    if (screen.width < 768) {
      $('#rich-media-popup .video-section').html(
        '<iframe src="' + container.dataset.videomobile + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe>' +
        '<div class="video-section-popup"><span>' + window.theme.strings.close + ' X</span></div>'
      );
    } else {
      $('#rich-media-popup .video-section').html(
        '<iframe src="' + container.dataset.video + '?title=0&amp;byline=0&amp;portrait=0&amp;sidedock=0" width="100%" height="100%" frameborder="0" allow="autoplay;"></iframe>' +
        '<div class="video-section-popup"><span>' + window.theme.strings.close + ' X</span></div>'
      );
    }

    $('.video-section-popup').on("click", function(event) {
      $('#rich-media-popup').hide();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-carousel-with-header"]) return;
  try {
    
  $(document).ready(function() {
    $('.carousel').on('scroll', function() {
      $this = $(this);
      var scrollLeft = $this.scrollLeft();
      var scrollWidth = this.scrollWidth;
      var clientWidth = this.clientWidth;
      var scrollbarValue = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      var scrollbar = $this.parent().parent().next('.scrollbar-container').find('.carousel-scrollbar');

      scrollbar.val(scrollbarValue);
    });

    $(document).on('input', '.carousel-scrollbar', function() {
      $this = $(this);
      var overflowContainer = $this.closest('.scrollbar-container').prev('.carousel-wrapper').find('.carousel');
      var scrollWidth = overflowContainer.prop('scrollWidth');
      var clientWidth = overflowContainer.width();
      var scrollLeft = ($this.val() / 100) * (scrollWidth - clientWidth);

      overflowContainer.scrollLeft(scrollLeft);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-cookie-type"]) return;
  try {
    
  $(document).ready(function(){

    $('.section-heading').on('click', function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).siblings('.cookie-list').slideUp();
      } else {
        $(this).addClass('active');
        $(this).siblings('.cookie-list').slideDown();
      }
    })
  });

  } catch(e) { console.error(e); }
})();
})();
